import { BatchLinkPlugin } from '@orpc/client/plugins';
import { FEATURE_FLAGS } from '@erp/shared-types';
import { RPC_BATCH_MAX_SIZE } from '@erp/rpc';
import { isBooleanFeatureFlagEnabled } from 'src/integrations/feature-flags/feature-flags';

export function isBatchableRpcMethod(method: string): boolean {
  return method === 'GET';
}

export function isRpcBatchingEnabled(): boolean {
  return isBooleanFeatureFlagEnabled(
    FEATURE_FLAGS['orpc-batching-enabled'],
    false,
  );
}

export function createRpcBatchLinkPlugin() {
  return new BatchLinkPlugin({
    groups: [
      {
        condition: ({ request }) =>
          isBatchableRpcMethod(request.method) && isRpcBatchingEnabled(),
        context: {},
      },
    ],
    maxSize: RPC_BATCH_MAX_SIZE,
  });
}
